var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"start-over"},[_c('router-link',{staticClass:"r-flex",attrs:{"to":"/"}},[_c('div',{on:{"click":_vm.defaultState}},[_c('img',{staticClass:"start-over-img",attrs:{"src":require("../assets/images/buttons/blue-chevron-right.svg")}}),_c('span',{staticClass:"footer-link back-btn"},[_vm._v("Back to home")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }